import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, DEFAULT_CURRENCY_CODE, ErrorHandler, Injector, LOCALE_ID, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';
import { AppComponent } from './app.component';
import { NavbarComponent } from './components/shared/navbar/navbar.component';
import { FooterComponent } from './components/shared/footer/footer.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { PipesModule } from './pipes/pipes.module';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { rxStompServiceFactory } from './services/websocket/rx-stomp-service-factory';
import { RxStompService } from './services/websocket/rxstomp.service';
import { ToastComponent } from './components/shared/toast/toast.component';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { SpinnerComponent } from './components/shared/spinner/spinner.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { TermsConditionsComponent } from './pages/terms-conditions/terms-conditions.component';
import { CookiesComponent } from './pages/cookies/cookies.component';
import { registerLocaleData } from "@angular/common";
import localeEs from "@angular/common/locales/es";
import localeEsExtra from "@angular/common/locales/extra/es";
//import { ServiceWorkerModule } from '@angular/service-worker';
//import { environment } from '../environments/environment';
import { ModalsModule } from './components/modals/modals.module';
import { SignupPageComponent } from './pages/signup-page/signup-page.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared.module';
import { LoginAsComponent } from './components/shared/login-as/login-as.component';
import { RedirectComponent } from './redirect.component';
import { GlobalErrorHandler } from './core/logging/global-error.handler';
import { HttpLoggingInterceptor } from './core/logging/http-logging.interceptor';
import { setAppInjector } from './core/di/app-injector';
import { AuthInterceptor } from './interceptor/auth/auth.interceptor';
import { LoadingInterceptor } from './interceptor/loading/loading.interceptor';
import { TenantAsComponent } from './components/shared/tenant-as/tenant-as.component';
import { ConfigService } from './services/config/config.service';
import { PendingEventPage, AdminPendingEventDetails } from './components/admin/admin-pending-event/admin-pending-event-page';
import { KioskSyncPage, AdminKioskSyncDetails } from './components/admin/admin-kiosk-sync/admin-kiosk-sync-page';

registerLocaleData(localeEs, "es", localeEsExtra);

function getGoogleTagManagerId(): string | null {
  if (typeof window === 'undefined') {
    return 'GTM-MLQ5WDZH';
  }

  const hostname = window.location.hostname;
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

  return isLocalhost ? null : 'GTM-MLQ5WDZH';
}

@NgModule({
  declarations: [
    AppComponent,
    SpinnerComponent,
    SignupPageComponent,
    LoginAsComponent,
    RedirectComponent,
    PendingEventPage,
    AdminPendingEventDetails,
    KioskSyncPage,
    AdminKioskSyncDetails
  ],
  imports: [
    BrowserModule,
    RouterModule,
    ModalsModule,
    HttpClientModule,
    AppRoutingModule,
    PipesModule,
    NgxJsonViewerModule,
    SharedModule,
    ToastComponent,
    //ServiceWorkerModule.register('ngsw-worker.js', {
    //  enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
    //  registrationStrategy: 'registerImmediately'
    //}),
    BrowserAnimationsModule,

    TenantAsComponent,
    FooterComponent,
    NavbarComponent,
    PrivacyComponent,
    TermsConditionsComponent,
    CookiesComponent,
  ],
  providers: [{
    provide: RxStompService,
    useFactory: rxStompServiceFactory,
  },
  ConfigService, { provide: APP_INITIALIZER, useFactory: initializeApp, deps: [ConfigService], multi: true },
  { provide: ErrorHandler, useClass: GlobalErrorHandler },
  { provide: HTTP_INTERCEPTORS, useClass: HttpLoggingInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  { provide: LOCALE_ID, useValue: 'es' },
  { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
  { provide: LocationStrategy, useClass: PathLocationStrategy },
  { provide: 'googleTagManagerId', useValue: getGoogleTagManagerId() }
],
  exports: [],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(injector: Injector) {
    setAppInjector(injector);
  }
 }
export function initializeApp(configService: ConfigService) {
  return () => configService.loadConfig();
}
